import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import Logomark from "./Logomark";

const navSections = [
  { id: "about", key: "about" },
  { id: "services", key: "services" },
  { id: "capabilities", key: "capabilities" },
  { id: "projects", key: "projects" },
  { id: "presence", key: "presence" },
  { id: "careers", key: "careers" },
  { id: "contact", key: "contact" },
];

export default function Footer() {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <footer data-testid="site-footer" className="relative bg-[#0A0A0B] border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-8 lg:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <Logomark size={44} />
              <div className="border-l border-white/10 pl-3">
                <div className="font-display font-black text-xl text-white tracking-tight">
                  DEPP C&amp;M
                </div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-[#8B939C] mt-1">
                  S.A. DE C.V.
                </div>
              </div>
            </div>
            <p className="mt-6 text-[#A1A1AA] text-sm max-w-md leading-relaxed">
              {t.footer.tagline}
            </p>
            <div className="mt-6 flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-[#8B939C]">
              <span className="h-px w-6 bg-[#D4AF37]" />
              {lang === "es" ? "Petróleo · Gas · Ingeniería" : "Oil · Gas · Engineering"}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="overline mb-5">{t.footer.nav}</div>
            <ul className="space-y-2.5">
              {navSections.map((s) => (
                <li key={s.id}>
                  <button
                    onClick={() => scrollTo(s.id)}
                    data-testid={`footer-link-${s.id}`}
                    className="text-sm text-[#A1A1AA] hover:text-[#D4AF37] transition-colors"
                  >
                    {t.nav[s.key]}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="overline mb-5">{t.footer.contact}</div>
            <ul className="space-y-2.5 text-sm text-[#A1A1AA]">
              <li className="text-white font-semibold">advisory@deppcm.com</li>
              <li>+52 (993) 000 · 0000</li>
              <li>Villahermosa, Tabasco · México</li>
              <li>Houston, TX · USA</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#8B939C]">
            © {year} DEPP C&amp;M, S.A. DE C.V. — {t.footer.rights}
          </div>
          <div className="flex items-center gap-5 text-[11px] uppercase tracking-[0.2em]">
            <Link
              to="/capacidades"
              data-testid="footer-portfolio"
              className="text-[#8B939C] hover:text-[#D4AF37] transition-colors"
            >
              {t.nav.portfolio}
            </Link>
            <Link
              to="/privacidad"
              data-testid="footer-privacy"
              className="text-[#8B939C] hover:text-[#D4AF37] transition-colors"
            >
              {t.footer.privacy}
            </Link>
            <button
              onClick={() => scrollTo("careers")}
              data-testid="footer-careers"
              className="text-[#8B939C] hover:text-[#D4AF37] transition-colors"
            >
              {t.footer.careers}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
